document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-kwo-trust-rotator]').forEach(function (root) {
    var items = root.querySelectorAll('.kwo-bannertrust__item');
    var dots = root.querySelectorAll('.kwo-bannertrust__dot');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }, 2800);
  });
});
